<div class="fixed inset-0 bg-black/40 z-50 flex items-center justify-center" (click)="cancel()">
  <div class="bm-card bm-card-border bg-base-100 w-[95vw] h-[90vh] max-w-6xl flex flex-col"
       (click)="$event.stopPropagation()">
    <div class="bm-card-body flex-1 flex flex-col gap-3 overflow-hidden p-4">

      <div class="flex items-center gap-4 flex-wrap">
        <h3 class="bm-card-title flex-1">PickPoint-Station auswählen</h3>
        <div class="flex items-center gap-2">
          <label class="bm-fieldset-label m-0">Umkreis (km)</label>
          <input type="number" min="1" max="100" step="1" class="bm-input w-24"
                 [(ngModel)]="radiusKm" (ngModelChange)="onRadiusChange($event)" />
        </div>
        <div class="text-sm opacity-70">
          {{ stations().length }} Station{{ stations().length === 1 ? '' : 'en' }}
          @if (loading()) { · lädt… }
        </div>
        <button class="bm-btn bm-btn-ghost bm-btn-sm" (click)="cancel()">Schliessen</button>
      </div>

      <div class="flex-1 min-h-0 relative">
        <mgl-map
          class="absolute inset-0 z-0"
          [style]="'mapbox://styles/mapbox/streets-v11'"
          [zoom]="[11]"
          [center]="[centerLng, centerLat]"
        >
          <!-- Umkreis-Polygon -->
          <mgl-geojson-source id="radius-circle" [data]="radiusCircle()" />
          <mgl-layer
            id="radius-circle-fill"
            type="fill"
            source="radius-circle"
            [paint]="{ 'fill-color': '#1d4ed8', 'fill-opacity': 0.12 }"
          />
          <mgl-layer
            id="radius-circle-outline"
            type="line"
            source="radius-circle"
            [paint]="{ 'line-color': '#1d4ed8', 'line-opacity': 0.5, 'line-width': 1.5 }"
          />

          <!-- Ticket-/Store-Position -->
          <mgl-marker [lngLat]="[centerLng, centerLat]">
            <div class="marker-center" title="Auftragsort"></div>
          </mgl-marker>

          <!-- PickPoint-Stationen -->
          @for (s of stations(); track s.id) {
            @if (s.address_longitude != null && s.address_latitude != null) {
              <mgl-marker [lngLat]="[s.address_longitude!, s.address_latitude!]">
                <button class="marker-pp"
                        [class.selected]="selected()?.id === s.id"
                        [title]="s.name + ' (PP-' + s.pp_id + ')'"
                        (click)="selectStation(s)">
                  {{ s.name }} (PP-{{ s.pp_id }})
                </button>
              </mgl-marker>
            }
          }
        </mgl-map>
      </div>

      <div class="flex items-center gap-3">
        @if (selected(); as sel) {
          <div class="flex-1 text-sm">
            <span class="bm-badge bm-badge-info mr-2">PP-{{ sel.pp_id }}</span>
            <strong>{{ sel.name }}</strong> · {{ sel.address_street }}, {{ sel.address_zip }} {{ sel.address_city }}
          </div>
        } @else {
          <div class="flex-1 text-sm opacity-60">Bitte eine Station auf der Karte auswählen.</div>
        }
        <button class="bm-btn bm-btn-ghost" (click)="cancel()">Abbrechen</button>
        <button class="bm-btn bm-btn-primary" [disabled]="!selected()" (click)="confirm()">
          Übernehmen
        </button>
      </div>

    </div>
  </div>
</div>
